import * as styles from "../route-flow.styles.module.scss";

svg class=[styles.arrow, styles.arrowH] viewBox="0 0 30 20" aria-hidden="true"
  line x1="0" y1="10" x2="22" y2="10" stroke="currentColor" stroke-width="2"
  polygon points="22,5 30,10 22,15" fill="currentColor"
svg class=[styles.arrow, styles.arrowV] viewBox="0 0 20 30" aria-hidden="true"
  line x1="10" y1="0" x2="10" y2="22" stroke="currentColor" stroke-width="2"
  polygon points="5,22 10,30 15,22" fill="currentColor"
